import React, { useState, useEffect } from "react";
import { Table, Empty, Col, Row, Tooltip, message } from "antd";
import { MenuUnfoldOutlined, FileExcelOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import RequestHandler from "../../util/RequestHandler";
import CashFlowReportTableFilter from "../Filters/CashFlowReportTableFilter";
import { ColumnHelper } from "../../util/TableHelper";
import { odata, queryHelper } from "../Filters/Helper";
import { encodeQueryStringParams } from "../../util/QueryStringHelper";
import config from "../../util/ApiforContext";

const CashFlowDailyReport = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    currencyCode: "TRY",
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [isDigitStatusFromDate, setIsDigitStatusFromDate] = useState();

  const [liveBalance, setLiveBalance] = useState();
  const [transferredAmount, setTransferredAmount] = useState();

  const history = useHistory();
  const [currencyId, setCurrencyId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");
    if (tab === "daily") {
      setFilterValues();
    }

    getTableData();
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setIsDigitStatusFromDate(response.data.isDigitStatusFromDate);
        }
      }
    );
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    setCurrencyId(tableDataQueryOptions.values.currencyId ?? null);
    RequestHandler.post(
      `/CashFlowReport/GetDailyDataReport?$count=true`,
      tableDataQueryOptions.values,
      false
    ).then((response) => {
      if (response && response?.length > 0) {
        setTableData({
          data: response,
          currencyCode: tableDataQueryOptions.values.currencyCode
            ? tableDataQueryOptions.values.currencyCode
            : "TRY",
          total: response?.length,
          loading: false,
        });

        var transferredData = response?.find(
          (item) => item.isTransferred === true
        );
        if (transferredData) {
          setLiveBalance(transferredData.liveBalanceString);
          setTransferredAmount(transferredData.transferredBalanceString);
        }
      } else {
        setTableData({
          data: [],
          currencyCode: tableDataQueryOptions.values.currencyCode
            ? tableDataQueryOptions.values.currencyCode
            : "TRY",
          total: 0,
          loading: false,
        });
        setLiveBalance(0);
        setTransferredAmount(0);
      }
    });

    if (props.onFilterChange) {
      props.onFilterChange(tableDataQueryOptions);
    }
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        pageSize: p.pageSize,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    delete values["dateRange"];

    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const GoReportDetailFirmPageCollect = (value) => {
    history.push(`report-monthly-firm-details/${value}`);
  };

  const GoReportDetailFirmPagePayment = (value) => {
    history.push(`report-monthly-firm-details-payment/${value}`);
  };

  const renderDecimal = (value) =>
    value !== null
      ? isDigitStatusFromDate
        ? ColumnHelper.renderDecimal(value)
        : ColumnHelper.renderDecimal(value).split(",")[0]
      : null;

  const columns = [
    {
      title: "Tarih",
      dataIndex: "date",
      key: "date",
      align: "center",
      width: "10%",
      render: (text, record) => {
        if (record.isTransferred) {
          return "Devir";
        } else {
          return text == null ? " - " : moment(text).format("DD.MM.YYYY");
        }
      },
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectPlan",
      key: "collectPlan",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Gerçekleşen Tahsilat",
      dataIndex: "completedCollect",
      key: "completedCollect",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Kalan Tahsilat",
      dataIndex: "remainingCollect",
      key: "remainingCollect",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Ödeme Planı",
      dataIndex: "paymentPlan",
      key: "paymentPlan",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Gerçekleşen Ödeme",
      dataIndex: "completedPayment",
      key: "completedPayment",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Kalan Ödeme",
      dataIndex: "remainingPayment",
      key: "remainingPayment",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Fark",
      dataIndex: "difference",
      key: "difference",
      width: "1%",
      align: "center",
      render: renderDecimal,
    },
    {
      title: "Tahmini Bakiye",
      dataIndex: "estimatedBalance",
      key: "estimatedBalance",
      width: "1%",
      align: "center",
      render: renderDecimal,
    },
    {
      title: "Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => (
        <a
          onClick={() => {
            const query = encodeQueryStringParams({
              date: record.date,
              currencyId: currencyId,
              isCalculatedForMonth: false,
              isTransferred: record.isTransferred,
              currencyCode: tableData.currencyCode,
            });

            history.push(`/cash-flow-report-detail${query}`);
          }}
          style={{ fontSize: "130%" }}
        >
          <MenuUnfoldOutlined />
        </a>
      ),
    },
  ];

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };

    const queryString = queryHelper.getQueryFromValues(filterValues);

    // URL'i monthly_ prefix'li şekilde setle
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(filterValues)) {
      if (value !== undefined && value !== null) {
        searchParams.set(`daily_${key}`, value);
      }
    }

    history.replace({
      pathname: window.location.pathname,
      search: searchParams.toString(),
    });
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
    RequestHandler.post(
      `/CashFlowReport/ExportExcel`,
      {
        ...tableDataQueryOptions.values,
        isCalculatedForMonth: false,
      },
      false
    ).then((response) => {
      hideMessage();
      if (response) {
        window.open(
          `${
            config.apiUrl
          }/CashFlowReport/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={22} lg={23}>
          {" "}
        </Col>
        <Col
          xs={24}
          md={2}
          lg={1}
          style={{ textAlign: "right" }}
          hidden={tableData.data.length > 0 ? false : true}
        >
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ textAlign: "end", fontSize: 19 }}>
          Devreden : {transferredAmount} {tableData.currencyCode}
        </Col>
        <Col span={24} style={{ textAlign: "end", fontSize: 19 }}>
          Güncel Bakiye : {liveBalance} {tableData.currencyCode}
        </Col>
      </Row>

      <CashFlowReportTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        monthly={false}
        key={props.monthly ? "monthly-filter" : "daily-filter"}
        extraText="Varsayılan olarak bu günden itibaren 30 gün ve TRY para birimi listelenmektedir."
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(_, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: 50,
              pageSizeOptions: ["50", "100"],
              total: tableData.total,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default CashFlowDailyReport;
